import React, {useState, FC} from "react"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import tracking from "@irati-tracking/platform"
import {NavigationMenuModal, StyledNavigationMenuContainer} from "./styled"
import NavigationMenuContent from "../shared/NavigationMenuContent"

const ID = "mobile_navigation_menu"

interface Props {
  productName: string
}

const MobileNavigationMenu: FC<Props> = ({productName}) => {
  const [showMenu, setShowMenu] = useState<boolean>(false)

  const handleOnClick = () => {
    if (!showMenu) {
      tracking.navigationClick({type: "Navigation Menu", product: productName})
    }
    setShowMenu((current) => !current)
  }

  return (
    <>
      <StyledNavigationMenuContainer id={`${ID}_button`} onClick={handleOnClick}>
        <Icon icon={IconTypes.burgerMenu} size={24} />
      </StyledNavigationMenuContainer>
      <NavigationMenuModal id={`${ID}_modal`} show={showMenu} animation={false} onHide={handleOnClick}>
        <NavigationMenuContent onClick={handleOnClick} />
      </NavigationMenuModal>
    </>
  )
}

export default MobileNavigationMenu
